export default "/_next/static/assets/images/formio-placeholder-desktop.1ac1da21f235f52971813c5335310e34.png";